var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 7.113,
    height: 9.896,
    viewBox: "0 0 7.113 9.896",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-sort",
    "data-name": "Icon awesome-sort",
    d: "M1.789,9.748H7.705a.6.6,0,0,1,.423,1.019L5.17,13.725a.594.594,0,0,1-.843,0L1.366,10.767A.6.6,0,0,1,1.789,9.748Zm6.339-2.61L5.17,4.18a.594.594,0,0,0-.843,0L1.366,7.138a.6.6,0,0,0,.423,1.019H7.705A.6.6,0,0,0,8.128,7.138Z",
    transform: "translate(-1.191 -4.004)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSort);
export default __webpack_public_path__ + "static/media/icon-sort.a971451a4e6a04fd3d1811ab3f2bffb3.svg";
export { ForwardRef as ReactComponent };